// extracted by mini-css-extract-plugin
export default {"Title":"TopDrawer_Title__xPnHg","TopDrawer":"TopDrawer_TopDrawer__QF5ME","Open":"TopDrawer_Open__QLPUv","Close":"TopDrawer_Close__JoXfq"};